import { useState, useEffect } from "react";
import { Box, useTheme } from "@mui/material";
import { tokens } from "../../../../theme";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { getAllSections, deleteSection } from "../../../../api/section";
import { DataGridTopHeader } from "../../../../components/styled";
import { sectionTableColumns } from "../../../../data/mockTableColumns";
import AddIcon from "@mui/icons-material/Add";
import DashboardLayout from "../../../../components/global/DashboardLayout";
import DashboardHeader from "../../../../components/global/DashboardHeader";
import ActionButton from "../../../../components/shared/ActionButton";
import CreateSectionModal from "../../../../components/models/CreateSectionModal";
// import Snackbar from "../../../../components/shared/Snackbar";

const Sections = () => {
  const [sections, setSections] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    const fetchAllSections = async () => {
      try {
        const allSections = await getAllSections();
        setSections(allSections);
      } catch (error) {
        console.error("Error:", error);
      }
    };

    fetchAllSections();
  }, []);

  // const handleDeleteSection = async (id) => {
  //   try {
  //     await deleteSection();
  //     <Snackbar message='Section Deleted Successfully.' />
  //   } catch (error) {
  //     console.error("Error:", error);
  //   }
  // } 

  // Filtered sections based on search query
  const filteredSections = sections.filter((section) =>
    section.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <DashboardLayout>
      <Box display="flex" justifyContent="end">
        <ActionButton
          colors={colors}
          title="Add Section"
          icon={<AddIcon />}
          onClick={() => setOpenModal(true)}
        />
      </Box>

      <DashboardHeader
        title="Sections"
        subtitle="List of All Sections"
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
      />

      <DataGridTopHeader theme={theme}>
        <DataGrid
          rows={filteredSections}
          columns={sectionTableColumns}
          getRowId={(row) => row._id}
          checkboxSelection
          disableRowSelectionOnClick
          pageSizeOptions={[10, 20, 30]}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 10,
              },
            },
          }}
          slots={{
            toolbar: GridToolbar,
          }}
        />
      </DataGridTopHeader>

      {openModal && (
        <CreateSectionModal
          openModal={openModal}
          setOpenModal={setOpenModal}
          colors={colors}
        />
      )}
    </DashboardLayout>
  );
};

export default Sections;
